// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerIdentificationType {
    id: number;
    value: string;
    customerCategoryType: any;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
    isAllowMultipleActive: boolean;
    isEditable: boolean;
}

export class CustomerIdentificationType implements ICustomerIdentificationType, IBaseType {
    public id: number;
    public value: string;
    public customerCategoryType: any;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;
    public isAllowMultipleActive: boolean;
    public isEditable: boolean;

    /**
		Returns Arizona DL Number CustomerIdentificationType
	**/
    get ArizonaDriverLicense(): ICustomerIdentificationType {
        return this.FromId(1);
    }
    /**
		Returns Arizona ID Number CustomerIdentificationType
	**/
    get ArizonaIDNumber(): ICustomerIdentificationType {
        return this.FromId(2);
    }
    /**
		Returns OOS DL Credential CustomerIdentificationType
	**/
    get OutofStateDriverCredential(): ICustomerIdentificationType {
        return this.FromId(3);
    }
    /**
		Returns Passport ID CustomerIdentificationType
	**/
    get PassportID(): ICustomerIdentificationType {
        return this.FromId(4);
    }
    /**
		Returns SSN CustomerIdentificationType
	**/
    get SSN(): ICustomerIdentificationType {
        return this.FromId(5);
    }
    /**
		Returns EIN CustomerIdentificationType
	**/
    get EIN(): ICustomerIdentificationType {
        return this.FromId(6);
    }
    /**
		Returns Legacy Customer Number CustomerIdentificationType
	**/
    get LegacyCustomerNumber(): ICustomerIdentificationType {
        return this.FromId(7);
    }
    /**
		Returns Legacy Sequence Number CustomerIdentificationType
	**/
    get LegacySequenceNumber(): ICustomerIdentificationType {
        return this.FromId(8);
    }
    /**
		Returns Customer Number CustomerIdentificationType
	**/
    get CustomerID(): ICustomerIdentificationType {
        return this.FromId(9);
    }
    /**
		Returns Tribal Enrollment Number CustomerIdentificationType
	**/
    get TribalEnrollmentCard(): ICustomerIdentificationType {
        return this.FromId(10);
    }
    /**
		Returns OOS ID Credential  CustomerIdentificationType
	**/
    get OutofStateIdentificationCredential(): ICustomerIdentificationType {
        return this.FromId(11);
    }
    /**
		Returns INS Number CustomerIdentificationType
	**/
    get INSNumber(): ICustomerIdentificationType {
        return this.FromId(12);
    }
    /**
		Returns Military ID CustomerIdentificationType
	**/
    get MilitaryID(): ICustomerIdentificationType {
        return this.FromId(13);
    }
    /**
		Returns TIN CustomerIdentificationType
	**/
    get TIN(): ICustomerIdentificationType {
        return this.FromId(14);
    }
    /**
		Returns ITIN CustomerIdentificationType
	**/
    get ITIN(): ICustomerIdentificationType {
        return this.FromId(15);
    }
    /**
		Returns OIN CustomerIdentificationType
	**/
    get OtherIdentificationNumber(): ICustomerIdentificationType {
        return this.FromId(16);
    }
    /**
		Returns Dealer License  CustomerIdentificationType
	**/
    get DealerLicense(): ICustomerIdentificationType {
        return this.FromId(17);
    }
    /**
		Returns ELT CustomerIdentificationType
	**/
    get ELT(): ICustomerIdentificationType {
        return this.FromId(18);
    }
    /**
		Returns eID PPID CustomerIdentificationType
	**/
    get PPID(): ICustomerIdentificationType {
        return this.FromId(19);
    }
    /**
		Returns USDOT Number CustomerIdentificationType
	**/
    get USDOTNumber(): ICustomerIdentificationType {
        return this.FromId(20);
    }
    /**
		Returns Fuel Tax Account CustomerIdentificationType
	**/
    get FuelTaxAccount(): ICustomerIdentificationType {
        return this.FromId(21);
    }
    /**
		Returns Alien Number CustomerIdentificationType
	**/
    get AlienNumber(): ICustomerIdentificationType {
        return this.FromId(22);
    }
    /**
		Returns SEVIS ID CustomerIdentificationType
	**/
    get SEVISID(): ICustomerIdentificationType {
        return this.FromId(23);
    }
    /**
		Returns VISA Number CustomerIdentificationType
	**/
    get VISANumber(): ICustomerIdentificationType {
        return this.FromId(24);
    }
    /**
		Returns I 94 CustomerIdentificationType
	**/
    get I94(): ICustomerIdentificationType {
        return this.FromId(25);
    }
    /**
		Returns MPI CustomerIdentificationType
	**/
    get MPI(): ICustomerIdentificationType {
        return this.FromId(26);
    }
    /**
		Returns mID PPID CustomerIdentificationType
	**/
    get MIDPPID(): ICustomerIdentificationType {
        return this.FromId(27);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'ArizonaDriverLicense', customerCategoryType: 1, displayValue: 'Arizona DL Number', description: 'AZ Driver License Credential Identification Value  ', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('2', { id: 2, value: 'ArizonaIDNumber', customerCategoryType: 1, displayValue: 'Arizona ID Number', description: 'AZ ID Credential Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('3', { id: 3, value: 'OutofStateDriverCredential', customerCategoryType: 1, displayValue: 'OOS DL Credential', description: 'History Credential Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: true, isEditable: true });
        this._dictionary.add('4', { id: 4, value: 'PassportID', customerCategoryType: 1, displayValue: 'Passport ID', description: 'Passport Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('5', { id: 5, value: 'SSN', customerCategoryType: 1, displayValue: 'SSN', description: 'Social Security Number Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('6', { id: 6, value: 'EIN', customerCategoryType: 2, displayValue: 'EIN', description: 'Employer Identification Number Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('7', { id: 7, value: 'LegacyCustomerNumber', customerCategoryType: 3, displayValue: 'Legacy Customer Number', description: 'Legacy Customer Number Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('8', { id: 8, value: 'LegacySequenceNumber', customerCategoryType: 3, displayValue: 'Legacy Sequence Number', description: 'Legacy Sequence Number Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('9', { id: 9, value: 'CustomerID', customerCategoryType: 3, displayValue: 'Customer Number', description: 'Generated by the MAX Application when a new customer record is created. ', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('10', { id: 10, value: 'TribalEnrollmentCard', customerCategoryType: 1, displayValue: 'Tribal Enrollment Number', description: 'Enrollment number from the tribal card for a person', sortOrder: 999999, active: true, isAllowMultipleActive: true, isEditable: true });
        this._dictionary.add('11', { id: 11, value: 'OutofStateIdentificationCredential', customerCategoryType: 1, displayValue: 'OOS ID Credential ', description: 'History Credential Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: true, isEditable: true });
        this._dictionary.add('12', { id: 12, value: 'INSNumber', customerCategoryType: 1, displayValue: 'INS Number', description: 'INS Number Identification Value. To be used for INS Number, I-94 Number, A Number, Visa Number OR SEVIS ID', sortOrder: 999999, active: true, isAllowMultipleActive: true, isEditable: true });
        this._dictionary.add('13', { id: 13, value: 'MilitaryID', customerCategoryType: 1, displayValue: 'Military ID', description: 'Military ID Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('14', { id: 14, value: 'TIN', customerCategoryType: 2, displayValue: 'TIN', description: 'TIN Identification Value ', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('15', { id: 15, value: 'ITIN', customerCategoryType: 1, displayValue: 'ITIN', description: 'ITIN Identification Value ', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('16', { id: 16, value: 'OtherIdentificationNumber', customerCategoryType: 3, displayValue: 'OIN', description: 'Number created internally by ADOT for customers without an EIN or SSN. Required for SSC access. ', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('17', { id: 17, value: 'DealerLicense', customerCategoryType: 2, displayValue: 'Dealer License ', description: 'Dealer License Identification Value ', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('18', { id: 18, value: 'ELT', customerCategoryType: 2, displayValue: 'ELT', description: 'Electronic License Tax Identification Value ', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('19', { id: 19, value: 'PPID', customerCategoryType: 1, displayValue: 'eID PPID', description: 'Identification value used strictly by eID by MorphoTrust.', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('20', { id: 20, value: 'USDOTNumber', customerCategoryType: 2, displayValue: 'USDOT Number', description: 'USDOT Number', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('21', { id: 21, value: 'FuelTaxAccount', customerCategoryType: 2, displayValue: 'Fuel Tax Account', description: 'Conversion will use this type to convert TARGATS Customers. This identification type will be used to cover the following values: Supplier account number, Restricted Distributor account number, Vendor account number, Gas Tax Refund account number', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('22', { id: 22, value: 'AlienNumber', customerCategoryType: 1, displayValue: 'Alien Number', description: 'Alien Number Identification Value', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('23', { id: 23, value: 'SEVISID', customerCategoryType: 1, displayValue: 'SEVIS ID', description: 'SEVIS ID', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('24', { id: 24, value: 'VISANumber', customerCategoryType: 1, displayValue: 'VISA Number', description: 'VISA Number', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('25', { id: 25, value: 'I94', customerCategoryType: 1, displayValue: 'I 94', description: 'I 94', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('26', { id: 26, value: 'MPI', customerCategoryType: 2, displayValue: 'MPI', description: 'IID Vendor Identification Number', sortOrder: 999999, active: true, isAllowMultipleActive: true, isEditable: true });
        this._dictionary.add('27', { id: 27, value: 'MIDPPID', customerCategoryType: 1, displayValue: 'mID PPID', description: 'Identification value used strictly for mID (Mobile ID) by Idemia.', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
        this._dictionary.add('28', { id: 28, value: 'MotorCarrierAccountNumber', customerCategoryType: 3, displayValue: 'Motor Carrier Account Number', description: 'Motor Carrier Account Number', sortOrder: 999999, active: true, isAllowMultipleActive: false, isEditable: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerIdentificationType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerIdentificationType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerIdentificationType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerIdentificationType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerIdentificationType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
